<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex flex-start justify-md-start">
              <v-btn color="success" class="button-shadow mr-2" @click="isFindReport=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
              <v-btn color="success" class="button-shadow mr-2" to="/gl-report/list">
                <v-icon class="mr-2">mdi-check</v-icon>
                Done
              </v-btn>
              <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement('print-page')">
                <v-icon class="mr-2">mdi-printer</v-icon>
                Print
              </v-btn>
              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="xls"
                :name="getFileName()"
              >
              <v-btn 
                v-show="transactions.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" sm="12" md="12" lg="12" >
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <v-row>&nbsp;</v-row>
                <v-row justify="space-between">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;">
                    <tr>
                      <td style="width: 100px; vertical-align: top;"><img v-if="logo!=null" :src="logo.src" :height="logo.height" alt="Logo" /></td>
                      <td></td>
                      <td style="width: 35%; text-align: right; vertical-align: text-top">
                         <table v-if="ledger!=null" style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Ledger</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ ledger.ledgercode }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Start Date</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ new Date(ledger.startdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">End Date</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ new Date(ledger.enddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</span></td>
                          </tr>
                         </table> 
                      </td>
                    </tr>
                  </table>
                  <table style="width: 100%; padding-bottom: 10px;">
                    <tr>
                      <td>
                        <div align="center" style="padding: 0; line-height: 0;"><h3><b>Income Statement</b></h3></div>
                        <p align="center" style="padding: 0; line-height: 0;">
                          Period:
                          {{ new Date(ledger.startdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}&nbsp;- 
                          {{ new Date(ledger.enddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
                        </p>
                      </td>
                    </tr>
                    <tr><td><div style="height: 10px;">&nbsp;</div></td></tr>
                  </table>
                </v-row>
                <table style="width: 100%" cellpadding="0" cellspacing="0">
                    <tbody>
                    <tr>
                      <th :style="css['row-bottom-left']">REVENUE</th>
                      <th v-if="ledger.isDualCurrency==true" :style="css['row-bottom-right']">{{ ledger.secondaryCurrency }}</th>
                      <th :style="css['row-bottom-right']">{{ ledger.primaryCurrency }}</th>
                    </tr>
                    </tbody>
                    <tbody v-if="data_revenue.length!=0">
                        <tr v-for="(trans) in data_revenue"  v-bind:key="trans._id">
                          <td :style="css['row-left']"> {{ trans.accountname }}</td>
                          <td v-if="ledger.isDualCurrency==true" :style="css['row-right']">{{ TransAmount2(trans, true) }}</td>
                          <td :style="css['row-right']">{{ TransAmount(trans, true) }}</td>
                        </tr>
                        <tr><td><div style="height: 10px;">&nbsp;</div></td></tr>
                        <tr>
                          <td :style="css['row-top-left']">TOTAL REVENUE&nbsp;</td>
                          <td v-if="ledger.isDualCurrency==true" :style="css['row-top-right']">{{ sum_revenue2 }}</td>
                          <td :style="css['row-top-right']">{{ sum_revenue }}</td>
                        </tr>
                    </tbody>
                    <tr><td><div style="height: 20px;">&nbsp;</div></td></tr>
                    <tbody v-if="data_expense.length!=0">
                      <tr>
                        <th :style="css['row-bottom-left']">EXPENSE</th>
                        <th v-if="ledger.isDualCurrency==true" :style="css['row-bottom-right']"></th>
                        <th :style="css['row-bottom-right']"></th>
                      </tr>
                    </tbody>
                    <tbody v-if="data_expense.length!=0">
                        <tr v-for="(trans) in data_expense"  v-bind:key="trans._id">
                          <td :style="css['row-left']"> {{ trans.accountname }}</td>
                          <td v-if="ledger.isDualCurrency==true" :style="css['row-right']">{{ TransAmount2(trans, false) }}</td>
                          <td :style="css['row-right']">{{ TransAmount(trans, false) }}</td>
                        </tr>
                        <tr><td><div style="height: 10px;">&nbsp;</div></td></tr>
                        <tr>
                          <td :style="css['row-top-left']">TOTAL EXPENSE&nbsp;</td>
                          <td v-if="ledger.isDualCurrency==true" :style="css['row-top-right']">{{ sum_expense2 }}</td>
                          <td :style="css['row-top-right']">{{ sum_expense }}</td>
                        </tr>
                    </tbody>
                    <tr><td><div style="height: 20px;">&nbsp;</div></td></tr>
                    <tbody>
                      <tr v-if="data_payroll.length!=0">
                        <th :style="css['row-bottom-left']">PAYROLL</th>
                        <th v-if="ledger.isDualCurrency==true" :style="css['row-bottom-right']"></th>
                        <th :style="css['row-bottom-right']"></th>
                      </tr>
                    </tbody>
                    <tbody v-if="data_payroll.length!=0">
                        <tr v-for="(trans) in data_payroll"  v-bind:key="trans._id">
                          <td :style="css['row-left']">{{ trans.accountname }}</td>
                          <td v-if="ledger.isDualCurrency==true" :style="css['row-right']">{{ TransAmount2(trans, false) }}</td>
                          <td :style="css['row-right']">{{ TransAmount(trans, false) }}</td>
                        </tr>
                        <tr><td><div style="height: 10px;">&nbsp;</div></td></tr>
                        <tr>
                          <td :style="css['row-top-left']">TOTAL PAYROLL&nbsp;</td>
                          <td v-if="ledger.isDualCurrency==true" :style="css['row-top-right']">{{ sum_payroll2 }}</td>
                          <td :style="css['row-top-right']">{{ sum_payroll }}</td>
                        </tr>
                    </tbody>
                    <tr><td><div style="height: 20px;">&nbsp;</div></td></tr>
                    <tbody>
                        <tr>
                          <td :style="css['row-top-left']">OPERATING INCOME&nbsp;</td>
                          <td v-if="ledger.isDualCurrency==true" :style="css['row-top-right']">{{ op_income2 }}</td>
                          <td :style="css['row-top-right']">{{ op_income }}</td>
                        </tr>
                    </tbody>
                    <tr><td><div style="height: 20px;">&nbsp;</div></td></tr>
                    <tbody v-if="data_other.length!=0">
                    <tr>
                      <th :style="css['row-bottom-left']">OTHER INCOME & EXPENSE</th>
                      <th v-if="ledger.isDualCurrency==true" :style="css['row-bottom-right']">{{ ledger.secondaryCurrency }}</th>
                      <th :style="css['row-bottom-right']">{{ ledger.primaryCurrency }}</th>
                    </tr>
                    </tbody>
                    <tbody v-if="data_other.length!=0">
                        <tr v-for="(trans) in data_other"  v-bind:key="trans._id">
                          <td :style="css['row-left']"> {{ trans.accountname }}</td>
                          <td v-if="ledger.isDualCurrency==true" :style="css['row-right']">{{ TransAmount2(trans, true) }}</td>
                          <td :style="css['row-right']">{{ TransAmount(trans, true) }}</td>
                        </tr>
                        <tr><td><div style="height: 10px;">&nbsp;</div></td></tr>
                        <tr>
                          <td :style="css['row-top-left']">TOTAL OTHER INCOME & EXPENSE&nbsp;</td>
                          <td v-if="ledger.isDualCurrency==true" :style="css['row-top-right']">{{ sum_other2 }}</td>
                          <td :style="css['row-top-right']">{{ sum_other }}</td>
                        </tr>
                    </tbody>
                    <tr><td><div style="height: 20px;">&nbsp;</div></td></tr>
                    <tbody>
                        <tr>
                          <td :style="css['row-top-left']">NET INCOME&nbsp;</td>
                          <td v-if="ledger.isDualCurrency==true" :style="css['row-top-right']">{{ net_income2 }}</td>
                          <td :style="css['row-top-right']">{{ net_income }}</td>
                        </tr>
                    </tbody>
                    <tr><td><div style="height: 20px;">&nbsp;</div></td></tr>
                </table>
                <p style="margin-top: 0; margin-bottom: 70px">&nbsp;</p>
                <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div>
    <v-dialog
      v-model="isFindReport"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Find Report</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-select
                  :items="glledgers.map(x => {
                            return {text: x.ledgername, value: x._id};
                          })"
                  v-model="find_query.ledgerid"
                  label="Ledger"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-menu
                  ref="menu_startdate"
                  v-model="menu_startdate"
                  :close-on-content-click="false"
                  :return-value.sync="find_query.startdate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      v-model="find_query.startdate"
                      label="Start Date"
                      v-bind="attrs"
                      v-bind:value="find_query.startdate"
                      v-on:change="onChangeDate($event, 'start')"
                      v-on="on"
                      persistent-hint
                      single-line hint="Please enter start date">
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="find_query.startdate"
                    no-title
                    scrollable
                  >
                  <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu_startdate = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="onChangeDate(find_query.startdate, 'start'); $refs.menu_startdate.save(find_query.startdate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-menu
                  ref="menu_enddate"
                  v-model="menu_enddate"
                  :close-on-content-click="false"
                  :return-value.sync="find_query.enddate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      v-model="find_query.enddate"
                      label="End Date"
                      v-bind="attrs"
                      v-bind:value="find_query.enddate"
                      v-on:change="onChangeDate($event, 'end')"
                      v-on="on"
                      persistent-hint
                      single-line hint="Please enter end date">
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="find_query.enddate"
                    no-title
                    scrollable
                  >
                  <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu_enddate = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="onChangeDate(find_query.enddate, 'end'); $refs.menu_enddate.save(find_query.enddate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isFindReport = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="resetReport"
          >
            Reset
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findReport"
          >
            Find
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </v-container>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    import { getLogo, getFirstDay, getLastDay, formatStdDate } from '../../../util/tools';
    export default {
        name: 'PrintPage',
        data(){
          return {
            logo: null,
            isFindReport: false,
            menu_startdate: null,
            menu_enddate: null,
            reportname: 'IS', 
            accountname: 'All', 
            digits: null,
            ledger: {},
            find_query: {},
            transactions: [],
            css: {
              'row-top-right': 'padding: 2px; text-align: right; border-top: 2px; border-top-style: solid;',
              'row-top-left': 'padding: 2px; text-align: left; border-top: 2px; border-top-style: solid; font-weight: bold;',
              'row-bottom-right': 'padding: 2px; text-align: right; border-bottom: 1px; border-bottom-style: solid;',
              'row-bottom-left': 'padding: 2px; text-align: left; border-bottom: 1px; border-bottom-style: solid;',
              'row-left': 'text-align: left; padding: 2px;',
              'row-right': 'text-align: right; padding: 2px;',
            },
            formatStdDate: formatStdDate,
          };
        },
        computed: {
          ...mapState('GLLedger', ['glledgers']),
          data_revenue(){
            let result = this.transactions.filter(trans=>trans.accountclass=='Revenue');
            return result;
          },
          data_expense(){
            let result = this.transactions.filter(trans=>trans.accountclass=='Expense');
            return result;
          },
          data_payroll(){
            let result = this.transactions.filter(trans=>trans.accountclass=='Payroll');
            return result;
          },
          data_other(){
            let result = this.transactions.filter(trans=>trans.accountclass=='Other');
            return result;
          },
          sum_revenue(){
            let result = this.transactions.filter(trans=>trans.accountclass=='Revenue');
            result = result.reduce((a, b) => a + (b.creditAmount-b.debitAmount), 0);
            result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
            return result;
          },
          sum_revenue2(){
            let result = this.transactions.filter(trans=>trans.accountclass=='Revenue');
            result = result.reduce((a, b) => a + (b.creditAmount2-b.debitAmount2), 0);
            result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
            return result;
          },
          sum_expense(){
            let result = this.transactions.filter(trans=>trans.accountclass=='Expense');
            result = result.reduce((a, b) => a + (b.debitAmount-b.creditAmount), 0);
            result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
            return result;
          },
          sum_expense2(){
            let result = this.transactions.filter(trans=>trans.accountclass=='Expense');
            result = result.reduce((a, b) => a + (b.debitAmount2-b.creditAmount2), 0);
            result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
            return result;
          },
          sum_payroll(){
            let result = this.transactions.filter(trans=>trans.accountclass=='Payroll');
            result = result.reduce((a, b) => a + (b.debitAmount-b.creditAmount), 0);
            result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
            return result;
          },
          sum_payroll2(){
            let result = this.transactions.filter(trans=>trans.accountclass=='Payroll');
            result = result.reduce((a, b) => a + (b.debitAmount2-b.creditAmount2), 0);
            result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
            return result;
          },
          sum_other(){
            let result = this.transactions.filter(trans=>trans.accountclass=='Other');
            result = result.reduce((a, b) => a + (b.creditAmount-b.debitAmount), 0);
            result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
            return result;
          },
          sum_other2(){
            let result = this.transactions.filter(trans=>trans.accountclass=='Other');
            result = result.reduce((a, b) => a + (b.creditAmount2-b.debitAmount2), 0);
            result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
            return result;
          },
          op_income(){
            let revenue = this.transactions.filter(trans=>trans.accountclass=='Revenue');
            let expense = this.transactions.filter(trans=>trans.accountclass=='Expense');
            let payroll = this.transactions.filter(trans=>trans.accountclass=='Payroll');
            let revenue_sum = revenue.reduce((a, b) => a + (b.creditAmount-b.debitAmount), 0);
            let expense_sum = expense.reduce((a, b) => a + (b.creditAmount-b.debitAmount), 0);
            let payroll_sum = payroll.reduce((a, b) => a + (b.creditAmount-b.debitAmount), 0);
            let income = revenue_sum + expense_sum + payroll_sum;
            income = income.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
            return income;
          },
          op_income2(){
            let revenue = this.transactions.filter(trans=>trans.accountclass=='Revenue');
            let expense = this.transactions.filter(trans=>trans.accountclass=='Expense');
            let payroll = this.transactions.filter(trans=>trans.accountclass=='Payroll');
            let revenue_sum = revenue.reduce((a, b) => a + (b.creditAmount2-b.debitAmount2), 0);
            let expense_sum = expense.reduce((a, b) => a + (b.creditAmount2-b.debitAmount2), 0);
            let payroll_sum = payroll.reduce((a, b) => a + (b.creditAmount2-b.debitAmount2), 0);
            let income = revenue_sum + expense_sum + payroll_sum;
            income = income.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
            return income;
          },
          net_income(){
            let revenue = this.transactions.filter(trans=>trans.accountclass=='Revenue');
            let expense = this.transactions.filter(trans=>trans.accountclass=='Expense');
            let payroll = this.transactions.filter(trans=>trans.accountclass=='Payroll');
            let other = this.transactions.filter(trans=>trans.accountclass=='Other');
            let revenue_sum = revenue.reduce((a, b) => a + (b.creditAmount-b.debitAmount), 0);
            let expense_sum = expense.reduce((a, b) => a + (b.creditAmount-b.debitAmount), 0);
            let payroll_sum = payroll.reduce((a, b) => a + (b.creditAmount-b.debitAmount), 0);
            let other_sum = other.reduce((a, b) => a + (b.creditAmount-b.debitAmount), 0);
            let income = revenue_sum + expense_sum + payroll_sum + other_sum;
            income = income.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
            return income;
          },
          net_income2(){
            let revenue = this.transactions.filter(trans=>trans.accountclass=='Revenue');
            let expense = this.transactions.filter(trans=>trans.accountclass=='Expense');
            let payroll = this.transactions.filter(trans=>trans.accountclass=='Payroll');
            let other = this.transactions.filter(trans=>trans.accountclass=='Other');
            let revenue_sum = revenue.reduce((a, b) => a + (b.creditAmount2-b.debitAmount2), 0);
            let expense_sum = expense.reduce((a, b) => a + (b.creditAmount2-b.debitAmount2), 0);
            let payroll_sum = payroll.reduce((a, b) => a + (b.creditAmount2-b.debitAmount2), 0);
            let other_sum = other.reduce((a, b) => a + (b.creditAmount2-b.debitAmount2), 0);
            let income = revenue_sum + expense_sum + payroll_sum + other_sum;
            income = income.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
            return income;
          },
        },
        methods: {
          ...mapActions('GLLedger', ['getGLLedgersRequest']),
          ...mapActions('GLReport', ['findGLReportISRequest', 'getGLReportISRequest']),
          ...mapActions('SystemSetting', ["getSetting"]),
          PrintElement(divid) {
            var content = document.getElementById(divid).innerHTML;
            var mywindow = window.open('', 'Print', 'height=800,width=1000,menubar=0,location=0,status=0,titlebar=0,toolbar=0');

            mywindow.document.write('<html>');
            mywindow.document.write('<head><title>'+ `${this.companycode} ${this.reportname} ${ this.formatStdDate(this.ledger.startdate) }_${ this.formatStdDate(this.ledger.enddate) }` + '</title></head>');
            mywindow.document.write('<body onclick="window.print();">');  
            mywindow.document.write(content);
            mywindow.document.write('</body>');
            mywindow.document.write('</html>');

            mywindow.document.close();
            mywindow.focus()
            mywindow.print();
            return;
          },
          TransAmount(trans, isCredit){
            let result;
            if(isCredit==true) result = trans.creditAmount-trans.debitAmount;
            else result = trans.debitAmount-trans.creditAmount;
            result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
            return result;
          },
          TransAmount2(trans, isCredit){
            let result;
            if(isCredit==true) result = trans.creditAmount2-trans.debitAmount2;
            else result = trans.debitAmount2-trans.creditAmount2;
            result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
            return result;
          },
          resetReport(){
            this.find_query = {};
          },
          async findReport(){
            let data = await this.findGLReportISRequest(this.find_query);
            this.ledger = Object.assign([], data);
            this.transactions = Object.assign([], data.transactions);
            this.isFindReport = false;
          },
          onChangeDate(value, route) {
            let date = new Date(value);
            let start_date = getFirstDay(date);
            let end_date = getLastDay(date);

            if(route=='start') this.find_query = Object.assign({}, this.find_query, {startdate: start_date});
            if(route=='end') this.find_query = Object.assign({}, this.find_query, {enddate: end_date});
          },
          getFileName(){
            var name = `${this.ledger.ledgercode} Income Statement` + ' ' + `${formatStdDate(this.ledger.startdate)} - ${formatStdDate(this.ledger.startdate)}` ;
            return name + '.xls';
          },
          getJson(){
            let json = this.transactions.map(item=>{return {
              accountclass: item.accountclass,
              accountsubclass: item.accountsubclass,
              accountnum: item.accountnum,
              accountname: item.accountname,
              creditAmount: item.creditAmount,
              debitAmount: item.debitAmount,
            }});
            return json;
          },
        },
        async created () {
          let data = await this.getGLReportISRequest();
          if(this.glledgers.length==0)await this.getGLLedgersRequest();
          this.ledger = Object.assign([], data);
          this.transactions = Object.assign([], data.transactions);
          var companyid = localStorage.getItem("companyid");
          this.companycode = localStorage.getItem("companycode");
          this.logo = getLogo(companyid);
          let decimal = await this.getSetting({code: 'CurrencySettings', name: 'PrimaryDecimalPlaces'}, );
          this.digits = decimal!=null ? parseInt(decimal) : 0;
        },
    };
</script>

<style src="./Print.scss" lang="scss" scoped />
